import { getPath as i } from "./index357.mjs";
import { setPath as f } from "./index350.mjs";
function s(e, c, n, r) {
  const o = i(e, r);
  if (!Array.isArray(o))
    return r;
  const t = [...o];
  return t.splice(typeof n == "number" ? n : t.length, 0, c), f(e, t, r);
}
export {
  s as insertPath
};
